const options = {
  5: "bg-purple-900/5",
  10: "bg-purple-900/10",
  25: "bg-purple-900/25",
  50: "bg-purple-900/50",
  75: "bg-purple-900/75",
  90: "bg-purple-900/90",
  100: "bg-purple-900",
};

const from = {
  5: "from-purple-900/5",
  10: "from-purple-900/10",
  25: "from-purple-900/25",
  50: "from-purple-900/50",
  75: "from-purple-900/75",
  90: "from-purple-900/90",
  100: "from-purple-900",
};

export default function getBackgroundPurple900(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
